export const TIER_TIMEOUT_MS = {
    'client-bff': 300000,
    bff: 300000,
    'backend-external': 600000,
};
